import ignore from 'ignore';
import type { StoreFileAction } from '~/types/actions';

export function filterFilesByGitignore(
  files: StoreFileAction[],
  gitignoreContent: string,
  trackedFilePaths: Set<string> // pass in paths already tracked by git
): StoreFileAction[] {
  if (!gitignoreContent) {
    return files;
  }

  const ig = ignore().add(gitignoreContent);

  return files.filter(file => {
    if (file.type !== 'file') {
      return true;
    }

    const relativePath = file.filePath.startsWith('/')
      ? file.filePath.substring(1)
      : file.filePath;

    // ✅ Keep tracked files even if ignored
    if (trackedFilePaths.has(relativePath)) {
      return true;
    }

    // Otherwise apply ignore rules
    return !ig.ignores(relativePath);
  });
}